export enum IntentKind {
    ALBUM_PAGE = 'AlbumPageIntent',
    ARTIST_PAGE = 'ArtistPageIntent',
    HOME_PAGE = 'HomePageIntent',
    BROWSE_PAGE = 'BrowsePageIntent',
    BROWSE_DETAIL_PAGE = 'BrowseDetailPageIntent',
    BROWSE_PLAYLISTS_PAGE = 'BrowsePlaylistsPageIntent',
    BROWSE_DETAIL_PAGINATION = 'BrowseDetailPaginationIntent',
    PLAYLIST_PAGE = 'PlaylistPageIntent',
    ROOM_PAGE = 'RoomPageIntent',
    SEE_ALL_PAGE = 'SeeAllPageIntent',
    SEE_ALL_PAGINATION = 'SeeAllPaginationIntent',
    SEARCH_PAGE = 'SearchPageIntent',

    // Common/shared types
    GET_STATIC_CANONICAL = 'GetStaticCanonicalUrlIntent',
    DETAIL_PAGE = 'DetailPageIntent',
    CONTEXT_MENU_INTENT = 'ContextMenuIntent',
    MODIFY_PLAYLIST_INTENT = 'ModifyPlaylistIntent',
    QUERY_PLAYBACK_INTENT = 'QueryPlaybackIntent',
    TRACK_METADATA_INTENT = 'TrackMetadataIntent',
    USER_COMPONENTS_INTENT = 'UserComponentsIntent',

    // Library Content
    LIBRARY_LIST_PAGE = 'LibraryListPageIntent',
    LIBRARY_PLAYLISTS = 'LibraryPlaylistsIntent',
    LIBRARY_PLAYLIST_PAGINATION = 'LibraryPlaylistPaginationIntent',
    LIBRARY_PLAYLIST_PAGE = 'LibraryPlaylistPageIntent',
    LIBRARY_RECENTLY_ADDED_PAGE = 'LibraryRecentlyAddedPageIntent',
    LIBRARY_TRACKS_PAGE = 'LibraryTracksPageIntent',
}
